export const moduleId = 'supplier';
export const state = {



};
export const actions = {



};
export const mutations = {
    setPageFlag(state,data){
        state.pageFlag  = data

    }


}

export const getters = {}



// WEBPACK FOOTER //
// ./src/store/modules/account-management/supplier/index.js